import { CONFIG } from '../config/config';
import { plateComponentUI } from '../config/plateComponentUI';
import { createMyPlugins } from '../config/typescript';
import { createDndPlugin } from '@udecode/plate';

export const dndPluings = createMyPlugins([createDndPlugin(CONFIG.dnd)], {
  components: plateComponentUI,
});
